module.exports = __webpack_public_path__ + "static/media/all-fp-dark-old.600ba61d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/all-fp-dark-old.svg
// module id = 352
// module chunks = 7